if (!customElements.get('coaster-design-property')) {
  customElements.define(
    'coaster-design-property',
    class CoasterDesignProperty extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('[data-coaster-design-wrapper]');
        this.label = this.querySelector('[data-coaster-design-label]');
        this.input = this.querySelector('[data-coaster-design-input]');
        this.hint = this.querySelector('[data-coaster-design-hint]');
        this.form = this.closest('product-form')?.querySelector('form');

        if (!this.wrapper || !this.label || !this.input || !this.form) return;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.handleSubmit, true);

        let initialOptions = [];
        try {
          initialOptions = JSON.parse(this.dataset.initialOptions || '[]');
        } catch (error) {
          console.error('Unable to read the selected coaster variant options.', error);
        }
        this.update(initialOptions);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.update(event.data.variant?.options || []);
        });
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit, true);
        this.variantChangeUnsubscriber?.();
      }

      getMode(options) {
        if (options.includes('Set of 4 (Mix & Match)')) return 'mix';
        if (options.includes('Single Coaster') || options.includes('Set of 4 (Same Design)')) return 'single';
        return null;
      }

      update(options) {
        const mode = this.getMode(options);
        const modeChanged = this.dataset.mode && this.dataset.mode !== mode;

        this.dataset.mode = mode || '';
        this.wrapper.hidden = !mode;
        this.input.disabled = !mode;
        this.input.required = Boolean(mode);

        if (!mode) {
          this.input.removeAttribute('name');
          this.input.removeAttribute('pattern');
          this.input.removeAttribute('title');
          return;
        }

        if (modeChanged) this.input.value = '';
        this.input.name = 'properties[Selected Design(s)]';

        if (mode === 'mix') {
          this.label.textContent = 'Enter 4 Design #s (e.g., #01, #04, #12, #18) (Required)';
          this.input.placeholder = '#01, #04, #12, #18';
          this.input.pattern = String.raw`\s*#?\d+\s*,\s*#?\d+\s*,\s*#?\d+\s*,\s*#?\d+\s*`;
          this.input.title = 'Enter four design numbers separated by commas, for example: #01, #04, #12, #18.';
          if (this.hint) this.hint.textContent = 'Enter exactly four design numbers separated by commas.';
        } else {
          this.label.textContent = 'Enter Design # (Required)';
          this.input.placeholder = '#01';
          this.input.pattern = String.raw`\s*#?\d+\s*`;
          this.input.title = 'Enter one design number, for example: #01.';
          if (this.hint) this.hint.textContent = 'Enter one design number.';
        }
      }

      handleSubmit(event) {
        if (!this.input.required || this.input.checkValidity()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.input.reportValidity();
        this.input.focus();
      }
    }
  );
}
